import * as mapDataWorldModule from "@highcharts/map-collection/custom/world.geo.json";

const mapDataWorld = mapDataWorldModule.default || mapDataWorldModule;

const normalizeCountryCode = (value) =>
  typeof value === "string" ? value.trim().toUpperCase() : "";

const countryLookups = (mapDataWorld?.features || []).reduce(
  (lookups, feature) => {
    const countryCode = normalizeCountryCode(feature?.properties?.["iso-a2"]);
    if (countryCode) {
      lookups.keyByCode[countryCode] = feature?.properties?.["hc-key"] || null;
      lookups.nameByCode[countryCode] = feature?.properties?.name || countryCode;
    }
    return lookups;
  },
  { keyByCode: {}, nameByCode: {} }
);

export const getCountryKeyByCode = (value) => {
  const countryCode = normalizeCountryCode(value);
  if (!countryCode) {
    return null;
  }

  return countryLookups.keyByCode[countryCode] || null;
};

export const getCountryNameFromCode = (value) => {
  const countryCode = normalizeCountryCode(value);
  if (!countryCode) {
    return "";
  }

  return countryLookups.nameByCode[countryCode] || countryCode;
};
